<template>
  <div class="check-in-report">
    <div style="margin-bottom: 10px">
      <el-input
        v-model="search.name"
        style="width: 200px; margin-right: 10px"
        placeholder="姓名"
        size="small"
      ></el-input>
      <el-input
        v-model="search.contact"
        style="width: 200px; margin-right: 10px"
        placeholder="聯絡電話"
        size="small"
      ></el-input>
      <el-select
        v-model="search.arrivalPort"
        multiple
        collapse-tags
        style="margin-right: 20px; width: 480px"
        placeholder="請選擇抵澳口岸"
        size="small"
      >
        <el-option
          v-for="port in ports"
          :key="port.CODE"
          :label="port.TEXT"
          :value="port.CODE"
        >
        </el-option>
      </el-select>
      <el-row style="margin-top: 0.5rem; margin-bottom: 0.5rem">
        <el-date-picker
          v-model="search.date"
          style="margin-right: 20px"
          type="daterange"
          :clearable="false"
          range-separator="-"
          :start-placeholder="$t('app.arrivalDateBegin')"
          :end-placeholder="$t('app.arrivalDateEnd')"
          size="small"
        >
        </el-date-picker>
        <el-time-select
          placeholder="到達時間起"
          style="width: 150px"
          v-model="search.startTime"
          :picker-options="{
            start: '08:30',
            step: '00:10',
            end: '18:30',
          }"
          size="small"
        >
        </el-time-select>
        -
        <el-time-select
          placeholder="到達時間止"
          style="width: 150px; margin-right: 20px"
          v-model="search.endTime"
          :picker-options="{
            start: '08:30',
            step: '00:10',
            end: '18:30',
            minTime: search.startTime,
          }"
          size="small"
        >
        </el-time-select>
        <el-button type="primary" @click="reset" size="small">{{
          $t("app.reset")
        }}</el-button>
        <el-button
          type="success"
          icon="el-icon-search"
          @click="getList"
          size="small"
        >
          查詢報表
        </el-button>
      </el-row>
    </div>

    <el-select
      v-model="columnKey"
      style="width: 300px"
      multiple
      collapse-tags
      placeholder="自定義列"
      clearable
      size="small"
    >
      <el-option
        v-for="item in initColumn"
        :key="item.Code"
        :label="item.Display"
        :value="JSON.stringify(item)"
      >
      </el-option>
    </el-select>
    <BookTypeOption
      v-model="bookType"
      style="margin-left: 20px; margin-right: 10px"
    />
    <el-button
      style="margin-bottom: 20px"
      type="primary"
      icon="el-icon-document"
      @click="handleDownload"
      size="small"
    >
      Export
    </el-button>
    <div class="table-container">
      <el-table
        :key="tableKey"
        stripe
        :data="tableData"
        style="width: 100%; color: black"
        ref="multipleTable"
        height="520"
      >
        <template v-for="col in column">
          <el-table-column
            :key="col.Code"
            align="center"
            :label="col.Display"
            :prop="col.Code"
          >
            <template slot-scope="scope">
              <div
                :class="{
                  'word-break': ['LastName', 'FirstName'].includes(col.Code),
                }"
              >
                {{ scope.row[col.Code] }}
              </div>
            </template>
          </el-table-column>
        </template>
      </el-table>
    </div>
    <el-pagination
      style="text-align: center; margin-top: 20px"
      background
      :total="total"
      :current-page.sync="currentPage"
      @size-change="handleSizeChange"
      @current-change="getList"
      :page-sizes="[10, 50, 200, 1000]"
      :page-size="size"
      layout="total, sizes, prev, pager, next, jumper"
    >
    </el-pagination>
  </div>
</template>

<script>
import BookTypeOption from "./components/BookTypeOption";
import { getArrivalPort, getColumns, getList } from "@/api/report/pickUpReport";
import { delEmpty, downloadFileByBlob, formatDate } from "@/utils/utils";
import { download } from "@/api/download";
export default {
  components: { BookTypeOption },
  data() {
    return {
      tableKey: true,
      filename: "",
      autoWidth: true,
      bookType: "",
      ports: [],
      columnKey: [],
      initColumn: [],
      search: {
        arrivalPort: [],
        date: [],
        startTime: "",
        endTime: "",
        name: "",
        contact: "",
      },
      size: 10,
      currentPage: 1,
      total: 100,
      tableData: [],
      floorList: [],
      title: "",
      exportUrl: "/PickUpServiceReport/Export",
    };
  },
  created() {
    this.init();
  },
  computed: {
    column() {
      if (this.columnKey.length < 1) {
        return this.initColumn;
      }
      return this.columnKey.map((i) => JSON.parse(i));
    },
  },
  watch: {
    columnKey: {
      handler() {
        this.tableKey = !this.tableKey;
      },
      deep: true,
    },
  },
  methods: {
    init() {
      this.getTypeList();
      this.getColumnGroup();
      this.getList();
    },
    getTypeList() {
      getArrivalPort().then((res) => {
        this.ports = res.data;
      });
    },
    getColumnGroup() {
      getColumns().then((res) => {
        this.initColumn = res.data;
      });
    },
    getList() {
      getList(
        delEmpty({
          BeginArrivalDate: this.search.date[0] || "",
          EndArrivalDate: this.search.date[1] || "",
          BeginArrivalTime: this.search.startTime,
          EndArrivalTime: this.search.endTime,
          ArrivalPort:
            this.search.arrivalPort.length > 0
              ? this.search.arrivalPort.join(",")
              : [],
          Name: this.search.name,
          Contact: this.search.contact,
          PageIndex: this.currentPage,
          PageSize: this.size,
        })
      ).then((res) => {
        this.total = res.data.Total;
        this.tableData = res.data.Items;
      });
    },
    reset() {
      this.search.startTime = "";
      this.search.endTime = "";
      this.search.date = [];
      this.search.arrivalPort = "";
      this.search.name = "";
      this.search.contact = "";
    },
    handleSizeChange(val) {
      this.size = val;
      this.getList();
    },
    handleDownload() {
      download(
        this.exportUrl,
        delEmpty({
          ExportMethod: this.bookType,
          HeaderValue: this.columnKey.map((_) => JSON.parse(_).Code).join(","),
          BeginArrivalDate: this.search.date[0] || "",
          EndArrivalDate: this.search.date[1] || "",
          BeginArrivalTime: this.search.startTime,
          EndArrivalTime: this.search.endTime,
          Name: this.search.name,
          Contact: this.search.contact,
          ArrivalPort:
            this.search.arrivalPort.length > 0
              ? this.search.arrivalPort.join(",")
              : [],
        })
      ).then((content) => {
        let downloadFileExtension = this.selectExtension(this.bookType);
        var blobContent = new Blob([content]);
        downloadFileByBlob(
          blobContent,
          "接載服務時間表" +
            formatDate(new Date(), "yyyy-MM-dd") +
            downloadFileExtension
        );
      });
    },
    selectExtension(bookType) {
      if (bookType === "xlsx") {
        return ".xls";
      } else if (bookType === "word") {
        return ".doc";
      } else if (bookType === "pdf") {
        return ".pdf";
      } else {
        return ".xls";
      }
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map((v) => filterVal.map((j) => v[j]));
    },
    createCellPos(n) {
      var ordA = "A".charCodeAt(0);
      var ordZ = "Z".charCodeAt(0);
      var len = ordZ - ordA + 1;
      var s = "";
      while (n >= 0) {
        s = String.fromCharCode((n % len) + ordA) + s;
        n = Math.floor(n / len) - 1;
      }
      return s;
    },
  },
};
</script>
<style lang="scss" scoped>
.check-in-report {
  background-color: #fff;
  padding: 15px;
  border: solid 1px #ccc;
  height: calc(100% - 80px);
  .table-container {
    height: calc(100% - 170px);
    overflow: auto;
  }
}
</style>
